import { Skeleton } from '../../ui/skeleton'

const StudentSidebarSkeleton = () => {
  return (
    <div className='absolute inset-0  flex items-start'>
      <div className='h-full w-80 border-none shadow-[0_4px_24px_rgba(0,139,192,0.12)] py-5'>
        <div className='bg-[#FAFCFF] min-h-16 w-full py-0 px-7'>
          <div className='h-full flex'>
            <div className='w-4/5 h-full flex items-center gap-3'>
              <Skeleton className='rounded-full w-[1.55rem] h-[1.55rem]' />
              <Skeleton className='w-24 h-[1.25rem]' />
            </div>
            <div className='w-1/5 h-full flex items-center justify-between text-white'>
              <Skeleton className='w-4 h-[1rem]' />
              <Skeleton className='w-5 h-5' />
            </div>
          </div>
        </div>

        <div className='w-full '>
          <div className='w-full bg-[#FAFCFF] pt-7 px-7 '>
            <Skeleton className='w-full h-10 mb-10' />

            <div className='w-full'>
              <div className='h-10'></div>
              <div className='flex flex-col gap-2 px-3'>
                {Array.from({ length: 2 }).map((_, index) => (
                  <div key={index} className='border-gray-200'>
                    <div className='p-0 h-full'>
                      <div className='w-full flex items-start group relative'>
                        <div className='flex items-center justify-center pt-1 absolute -left-4 -top-1'>
                          <Skeleton className='w-3 h-3' />
                        </div>
                        <div className='flex flex-col h-full gap-1'>
                          <Skeleton className='w-12 h-4' />
                          <Skeleton className='w-28 h-5' />
                        </div>
                      </div>
                    </div>
                    <div className='mt-1 text-sm text-black leading-relaxed h-[15vh] overflow-y-auto'>
                      <Skeleton className='w-full h-24' />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudentSidebarSkeleton
